import { Mail } from "lucide-react"
import { PendingSubscriptionEventType } from "../../../../../types"

interface Props {
  event_type: PendingSubscriptionEventType
  connectorVisible?: boolean
}

const EmailIcon = ({ event_type, connectorVisible = true }: Props) => {
  const getIconColor = () => {
    switch (event_type) {
      case "pending_subscription.lo_alert_email":
        return "text-blue-600"
      case "pending_subscription.user_alert_email":
        return "text-green-600"
      default:
        return "text-neutral-500"
    }
  }

  return (
    <div className="flex flex-col items-center relative">
      <div
        className={`w-8 h-8 rounded-full bg-white border-2 border-neutral-200 flex items-center justify-center ${getIconColor()}`}
      >
        <Mail size={16} />
      </div>
      {connectorVisible && (
        <div className="w-0.5 h-6 bg-neutral-200 mt-2 absolute top-full" />
      )}
    </div>
  )
}

export default EmailIcon
